import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponseWithPagination,
  SupportQuestionsResponseDataSchema,
  SupportSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof SupportSchema>
type Response = DataResponseWithPagination<z.infer<typeof SupportQuestionsResponseDataSchema>>

const getSupportQuestionsQueryKey = (query?: Query) => ["support", "newQuestions", query]

type Props = {
  query?: Query
  onSuccess?: (data: Response) => void
}

export const supportQuestionsQuery = ({ query, onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: getSupportQuestionsQueryKey(query),
    queryFn: async () => {
      const response = await axios.get<Response>("/support/entities/questions", { params: query })

      onSuccess?.(response.data)

      return response.data.data
    },
  })
}
